import ApiService from '../../../shared/services/api-service';
import commonActionCreators from '../../../shared/store/common/action-creators';
import myTrainingPhaseTypes from './commit-types';

const myTrainingProgramActionCreators = {
  fetchMyTrainingProgram() {
    return async (dispatch) => {
      return ApiService.get('/api/v1/my-training-program')
        .then(response => response.data)
        .then(data => {
          dispatch(this.setMyTrainingProgram(data));
        })
        .catch((error) => {
          return Promise.reject();
        });
    };
  },
  fetchTrainingPhasesForOit(oitGuid) {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchTrainingPhasesForOit'));
      const data = await ApiService.get(`/api/v1/oits/${oitGuid}/training-phases`)
        .then(response => response.data)
        .catch((error) => {
          dispatch(commonActionCreators.handleApiError(error));
          dispatch(this.setIsLoading('fetchTrainingPhasesForOit'));
          return Promise.reject();
        });
      dispatch(this.setIsLoading('fetchTrainingPhasesForOit'));
      if (data) {
        dispatch(this.fetchTrainingPhasesForOitSuccess(data));
      }
      return Promise.resolve();
    };
  },
  fetchTrainingPhasesForOitSuccess(trainingPhasesResponse) {
    return (dispatch) => {
      dispatch(this.pushTrainingPhases(trainingPhasesResponse.data));
    };
  },
  loadMyTrainingProgram() {
    return (dispatch, getState) => {
      const oitGuid = getState().common.userContext.userGuid;
      dispatch(this.fetchTrainingPhasesForOit(oitGuid));
      return dispatch(this.fetchMyTrainingProgram());
    };
  },
  pushTrainingPhases(trainingPhases) {
    return {
      trainingPhases,
      type: myTrainingPhaseTypes.PUSH_MY_TRAINING_PROGRAM_TRAINING_PHASES,
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: myTrainingPhaseTypes.SET_MY_TRAINING_PROGRAM_IS_LOADING,
    };
  },
  setMyTrainingProgram(responseData) {
    return {
      oit: responseData.data,
      type: myTrainingPhaseTypes.SET_MY_TRAINING_PROGRAM_OIT,
    };
  },
};

export default myTrainingProgramActionCreators;
